// /Components/History.js
// https://www.npmjs.com/package/history
// History allows us to change a browser history / route (page) the user is on / use redirects as seein in /APIs/Authorization.js

import { createBrowserHistory } from "history";

export default createBrowserHistory();
